import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import {
  CreativeIcon,
  NativeIcon,
  CopywriterIcon,
  ReviserIcon,
  QualityIcon,
  AutomaticIcon,
  LightIcon,
  StarIcon,
  UserCheckIcon,
  FileCheckIcon,
} from '../Icons/ContentServicesIcons'
import {quoteKinds} from '../Services/api.jsx'
import cx from 'classnames'

export default function ContentFeatures({title, quoteKind}) {
  const featuresIcons = (obj) => {
    const {
      creative,
      native,
      copywriter,
      reviser,
      quality,
      automatic,
      light,
      mostReliableAI,
      optionalHumanIntervention,
      preservesLayout,
    } = obj
    return (
      <div className={'content-features__header-features'}>
        <div
          className={cx('content-features__header-feature', {
            included: creative,
          })}
        >
          <p>
            <CreativeIcon />
            {i18n.t('Components.ContentFeatures.creative')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: native,
          })}
        >
          <p>
            <NativeIcon />
            {i18n.t('Components.ContentFeatures.native')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: copywriter,
          })}
        >
          <p>
            <CopywriterIcon />
            {i18n.t('Components.ContentFeatures.copywriter')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: reviser,
          })}
        >
          <p>
            <ReviserIcon />
            {i18n.t('Components.ContentFeatures.reviser')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: quality,
          })}
        >
          <p>
            <QualityIcon />
            {i18n.t('Components.ContentFeatures.quality')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: automatic,
          })}
        >
          <p>
            <LightIcon />
            {i18n.t('Components.ContentFeatures.automatic')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: light,
          })}
        >
          <p>
            <AutomaticIcon />
            {i18n.t('Components.ContentFeatures.light')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: mostReliableAI,
          })}
        >
          <p>
            <StarIcon />
            {i18n.t('Components.ContentFeatures.mostReliableAI')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: optionalHumanIntervention,
          })}
        >
          <p>
            <UserCheckIcon />
            {i18n.t('Components.ContentFeatures.optionalHumanIntervention')}
          </p>
        </div>
        <div
          className={cx('content-features__header-feature', {
            included: preservesLayout,
          })}
        >
          <p>
            <FileCheckIcon />
            {i18n.t('Components.ContentFeatures.preservesLayout')}
          </p>
        </div>
      </div>
    )
  }

  //included: creative, native, copywriter, reviser, quality, automatic, light
  const renderFeatures = () => {
    switch (quoteKind) {
      case quoteKinds.translationRevision:
        return featuresIcons({native: true, reviser: true, quality: true})
      case quoteKinds.translation:
        return featuresIcons({native: true, quality: true})
      case quoteKinds.postediting:
        return featuresIcons({automatic: true, light: true})
      case quoteKinds.transcreation:
        return featuresIcons({
          creative: true,
          native: true,
          copywriter: true,
          quality: true,
        })
      case quoteKinds.lara:
        return featuresIcons({
          mostReliableAI: true,
          optionalHumanIntervention: true,
          preservesLayout: true,
        })
      default:
        return featuresIcons({
          creative: false,
          native: false,
          copywriter: false,
          reviser: false,
          quality: false,
          automatic: false,
          light: false,
          mostReliableAI: false,
          optionalHumanIntervention: false,
          preservesLayout: false,
        })
    }
  }

  return (
    <div className={'content-features'}>
      <h4 className={'content-features__title'}>{title}</h4>
      {renderFeatures()}
    </div>
  )
}

ContentFeatures.propTypes = {
  title: PropTypes.string,
  quoteKind: PropTypes.oneOf([
    'postediting',
    'translation',
    'translation+revision',
    'transcreation',
    'lara_instant',
  ]),
}
